import React, { useState, useEffect } from 'react';
import '../Mobile.css';
import MobileTaxiMap from './MobileTaxiMap';
import MobileTaxiInfo from './MobileTaxiInfo';
import axios from 'axios';

function Mobile({ tripId }) {
  const [tripData, setTripData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTripData = async () => {
      try {
        // Use the tripId from URL parameters for the API call
        const response = await axios.get(`https://taxi-api.lezzoodevs.com/api/taxi/trip-track-rider?tripKey=${tripId}`);
        
        // Set trip data from API response

        if(response.data && response.data.success ){
          setTripData(response.data);
        }else{
          setTripData(null);
        }
        setLoading(false);
      } catch (err) {
        console.error('Error fetching trip data:', err);
        // Use null if API fails
        setTripData(null);
        setLoading(false);
      }
    };

    fetchTripData();
    // Poll for updates every 10 seconds
    const interval = setInterval(fetchTripData, 10000);
    return () => clearInterval(interval);
  }, [tripId]); // Add tripId as a dependency to re-fetch when it changes

  return (
    <div className="mobile-app">
      <header className="mobile-header">
        <div className="mobile-logo-container">
          <img 
            src="https://lezzoo.com/images/Group.png" 
            alt="Lezzoo" 
            className="mobile-logo" 
          />
        </div>
      </header>
      
      {loading || !tripData ? (
        <div className="mobile-loading-state">
          <div className="mobile-loading-container">
            <div className="mobile-loading-spinner"></div>
            <div className="mobile-loading-text">Loading your trip details...</div>
          </div>
        </div>
      ) : (
        <>
          {/* 1. Trip Status */}
          <div className="mobile-status-section">
            <h2 className="mobile-status-title">STATUS</h2>
            <div className="mobile-status-value">{tripData.trip_status_description}</div>
          </div>
          
          {/* 2. Map */}
          <div className="mobile-map-section">
            <MobileTaxiMap 
              driver={tripData.rider_info} 
              tripDetails={tripData.trip_details} 
            />
          </div>
          
          {/* 3. Trip Details & 4. Captain Info */}
          <div className="mobile-info-section">
            <MobileTaxiInfo 
              driver={tripData.rider_info} 
              tripDetails={tripData.trip_details} 
              status={tripData.trip_status} 
            />
          </div>
        </>
      )}
    </div>
  );
}

export default Mobile;
